import {IntermediatePart} from "../../intermediatePart";

export default class Fridge extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'fridge';
    this.partName = 'Fridge';
    this.translateId = "visualizer.kitchen.appliance.fridge";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Fridge());
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions())
      || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }

    this.setDefault(layout);
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    return [{
      propName: 'RoomLayout',
      propValue: this.getParent().layout.getCurrentLayoutAbbreviation()
    }];
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Appliances.Fridge;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
